/* Day to Night Landing — scoped page JS.
   Handles: hero gallery thumb toggle, hero size discovery buttons,
   newsletter form UX polish. Keyboard-operable. No dependencies. */
(function () {
  'use strict';

  var root = document.querySelector('.dtn-landing');
  if (!root) return;

  // ---------- Hero gallery ----------
  var galleries = root.querySelectorAll('[data-dtn-gallery]');
  galleries.forEach(function (gallery) {
    var thumbs = gallery.querySelectorAll('[data-dtn-thumb]');
    var mains = gallery.querySelectorAll('[data-dtn-main]');
    if (!thumbs.length || !mains.length) return;

    function activate(idx) {
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === idx);
        t.setAttribute('aria-selected', i === idx ? 'true' : 'false');
        t.setAttribute('tabindex', i === idx ? '0' : '-1');
      });
      mains.forEach(function (m, i) {
        m.classList.toggle('is-active', i === idx);
      });
    }

    thumbs.forEach(function (thumb, i) {
      thumb.setAttribute('role', 'tab');
      thumb.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      thumb.setAttribute('tabindex', i === 0 ? '0' : '-1');
      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        activate(i);
      });
      thumb.addEventListener('keydown', function (e) {
        var next;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = (i + 1) % thumbs.length;
        else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = (i - 1 + thumbs.length) % thumbs.length;
        else return;
        e.preventDefault();
        activate(next);
        thumbs[next].focus();
      });
    });
    activate(0);
  });

  // ---------- Hero size discovery ----------
  // These do NOT add to cart; they filter the linked collection URL by size
  // when the primary CTA is clicked. Selection is visual/discovery only.
  var sizeGroups = root.querySelectorAll('[data-dtn-sizes]');
  sizeGroups.forEach(function (group) {
    var buttons = group.querySelectorAll('button');
    var cta = document.querySelector(group.getAttribute('data-dtn-sizes-cta'));
    var baseHref = cta ? cta.getAttribute('href') : null;

    function selectSize(btn) {
      buttons.forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');

      if (cta && baseHref) {
        var size = btn.getAttribute('data-size') || btn.textContent.trim();
        var sep = baseHref.indexOf('?') === -1 ? '?' : '&';
        cta.setAttribute('href', baseHref + sep + 'filter.v.option.size=' + encodeURIComponent(size));
      }
    }

    buttons.forEach(function (btn) {
      btn.setAttribute('aria-pressed', 'false');
      btn.addEventListener('click', function () { selectSize(btn); });
    });
  });

  // ---------- Newsletter form (native Shopify /contact) ----------
  // Progressive enhancement: show inline feedback without navigating away.
  var forms = root.querySelectorAll('[data-dtn-newsletter]');
  forms.forEach(function (form) {
    var msg = form.querySelector('[data-dtn-form-message]');
    form.addEventListener('submit', function () {
      if (msg) {
        msg.textContent = '';
        msg.classList.remove('error', 'success');
      }
    });
  });
})();
